// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"c5c719dd","422":"56d9ef44"}[chunkId] + ".chunk.js";
};